/** The link shown in the card, without the scheme. */
export function shortLink(url: string): string {
  return url.replace(/^https?:\/\//, '')
}

/** "Alle annehmen" only pays off with more than one waiting request. */
export function offersApproveAll(pending: number): boolean {
  return pending > 1
}
